import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { FirmwareListScene } from 'scenes';

class FirmwareListContainer extends AbstractContainer {
  getTasks() {

    return [
      {
        group: 1,
        key: 'firmwares',
        exec: (done, failure) => {
          API.get('firmwares')
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <FirmwareListScene firmwares={results.firmwares} />
  }
}

export default FirmwareListContainer;
